var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import padding from "@irati/ui/src/global/padding";
import { H4 } from "@irati/ui/src/Headings";
import Button from "@irati/ui/src/Button";
export var StyledH4 = styled(H4)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-top: 20px;\n  padding-bottom: 30px;\n"], ["\n  padding-top: 20px;\n  padding-bottom: 30px;\n"])));
export var StyledDiv = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  max-width: 550px;\n"], ["\n  max-width: 550px;\n"])));
export var LeftAlign = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  text-align: left;\n"], ["\n  text-align: left;\n"])));
export var MarginRightButton = styled(Button)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-right: ", ";\n"], ["\n  margin-right: ", ";\n"])), padding.medium);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
